import(/* webpackMode: "eager" */ "/home/circleci/project/src/app/[pageLocale]/error.tsx");
